import React from 'react';
import { Helmet } from 'react-helmet';

const SEO = ({ 
  title = 'Yastudio - Vidéaste Mariage Alsace & Strasbourg | Films de Mariage Professionnels',
  description = 'Vidéaste mariage professionnel en Alsace, Strasbourg, Mulhouse, Colmar. Films de mariage cinématiques avec drone. Reportage vidéo mariage dans tout le Grand Est. Devis gratuit.',
  keywords = 'vidéaste mariage Alsace, vidéaste mariage Strasbourg, film de mariage Alsace, vidéo mariage Grand Est, vidéaste mariage Mulhouse, vidéaste mariage Colmar, film mariage drone Alsace, reportage vidéo mariage',
  image = 'https://customer-assets.emergentagent.com/job_alsace-wedding-pro/artifacts/ub2hh801_DSC01034.jpeg',
  url = 'https://www.videaste-mariage-strasbourg.fr'
}) => {
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />
      
      {/* Additional SEO */}
      <meta name="robots" content="index, follow" />
      <meta name="language" content="French" />
      <meta name="geo.region" content="FR-67" />
      <meta name="geo.placename" content="Strasbourg, Alsace" />
      <link rel="canonical" href={url} />
    </Helmet>
  );
};

export default SEO;